'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = _assign2.default || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _helpers = require('../../helpers');

var _redux = require('../../redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var withAlertHandler = function withAlertHandler(Component) {
  return (0, _reactRedux.connect)()(function (props) {
    var dispatch = props.dispatch;


    var setSnackbarMessage = function setSnackbarMessage(message) {
      dispatch((0, _redux.setSnackbarMessageAction)(message));
    };

    var handleSnackbarError = function handleSnackbarError(error) {
      var errorMessage = (0, _helpers.getErrorMessage)(error);

      if (errorMessage) {
        setSnackbarMessage(errorMessage);
      }
    };

    var mergedProps = _extends({}, props, {
      setSnackbarMessage: setSnackbarMessage,
      handleSnackbarError: handleSnackbarError
    });

    return _react2.default.createElement(Component, mergedProps);
  });
};

exports.default = withAlertHandler;